import React from 'react';

export default function Header(props) {
  return (<header className="pure-g">
      <div className="pure-u-1 pure-u-md-7-12" style={{display: 'flex', alignItems: 'center'}}></div>
      <div className="pure-u-1 pure-u-md-5-12"><div className="logo"><img src="/clinique.png" alt="Logo clinique" /></div></div>
    </header>);
}
